export const ESG_ENDPOINTS = {
  FRAMEWORKS: "/frameworks",
  DISCLOSURES: "/disclosures",
  QUANT_TARGETS: "/quantitative-targets",
  QUANT_TARGETS_BULK: "/quantitative-targets/bulk",
  QUANT_TARGETS_SEED: "/quantitative-targets/seed",
  TARGETS_SETTINGS_LISTS: "/targets/list",
  TARGETS_SETTINGS_BY_ID: (targetId) => `/targets/settings-details/${targetId}`,
  ESG_REPORT_PREVIEW_QUERY: "/esg-report-preview/query",
  ESG_REPORT_PREVIEW_LIST: "/esg-report-preview/list",
  ESG_REPORT_PREVIEW_FILTER_OPTIONS: "/esg-report-preview/filter-options",
  ESG_REPORT_PREVIEW: (id) => `/esg-report-preview${id ? `/${id}` : ""}`,
  ESG_REPORT_PREVIEW_COMPLETE: (id) => `/esg-report-preview/${id}/complete`,
  ESG_REPORT_PREVIEW_EXPORT: (id) => `/esg-report-preview/${id}/export`,
  ESG_INVITE_ACCEPT: "/esg-invites/accept",
  ESG_TARGET_DELETE: (targetId) => `/targets/delete/${targetId}`,
};
